// extracted by mini-css-extract-plugin
module.exports = {"zoom-button":"zoom-buttons_zoom-button__A0QAo","zoom-button--disabled":"zoom-buttons_zoom-button--disabled__0SwF1"};